import * as React from 'react';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useState } from "react";
import { getDocumentSignedSignature, postDocumentSignedSignature } from "../../service/documentSignedSignature";
import parse, { HTMLReactParserOptions, Element } from 'html-react-parser';
import { s3GetUrl } from "../../service/s3Service";
import dayjs from 'dayjs';
import { formatDateTime } from "../../utils/DateUtils";

export default function TaskDocumentSign(modalProps: any) {

  const id = modalProps?.id;
  const details = modalProps?.details;
  const employeeId = modalProps?.employeeId;
  const toast = React.useRef(null as any);
  console.log('details.employee_id == ', details.employee_id);
  console.log('employeeId == ', employeeId);

  const [document, setDocument] = useState<any>();
  const [employee, setEmployee] = useState<any>();
  const [documentSignature, setDocumentSignature] = useState<any>();
  const [employeeSignature, setEmployeeSignature] = useState<string>();
  const [canSign, setCanSign] = useState<boolean>(false);

  const [html, setHtml] = useState<any>([]);
  const [documentSignaturesClicked, setDocumentSignaturesClicked] = useState<number[]>([]);
  const [totalSignatures, setTotalSignatures] = useState<number>(0);

  async function sign() {
    modalProps.setGlobalLoading(true);

    try {
      await postDocumentSignedSignature(details.record_id);
      setTimeout(() => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Signed Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }, 500);
    }
    catch (e) {
      modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Sign Document', life: 3000 });
      modalProps.setGlobalLoading(false);
    }

  }


  function signatureClicked(index: number) {
    console.log("details ", details);
    if (details.employee_id !== employeeId && !canSign) {
      toast.current.show({ severity: 'error', summary: 'You are not allowed to sign this document', life: 3000 });
      return;
    }
    if (!employeeSignature) {
      toast.current.show({ severity: 'error', summary: 'Employee has no signature. Set under Employee profile before signing', life: 3000 });
      return;
    }
    if (!documentSignaturesClicked.includes(index))
      setDocumentSignaturesClicked([...documentSignaturesClicked, index]);
  }

  async function fetchData() {
    modalProps.setGlobalLoading(true);
    try {
      console.log(details)
      const resp = await getDocumentSignedSignature(details.record_id);
      setDocument(resp.content.document);
      setEmployee(resp.content.employee);
      setDocumentSignature(resp.content.document_signature);
      if (resp.content.employee.signature_s3_key) {
        const s3Url = await s3GetUrl(resp.content.employee.signature_s3_key);
        setEmployeeSignature(s3Url);
      }
      setCanSign(resp.content.canSign);
      // {
      //   document: {
      //     document_id: 'c4ae4398-8d23-4f9c-8da5-e810717589b1',
      //       client_id: '4c4751b5-735d-4436-a36b-f41fca319cc6',
      //       template_id: null,
      //       appointment_id: 'aaea90ea-4da1-11ef-9cb1-02393f980435',
      //       name: 'Site Appointment Agreement',
      //       content: `<p class="ql-align-center"><strong>Section16 (1)</strong></p><p class="ql-align-center"><strong>CHIEF EXECUTIVE OFFICER</strong></p><p class="ql-align-center">In terms of the Occupational Health and Safety Act no 85 of 1993 as amended.</p><p class="ql-align-center"><br></p><p class="ql-align-center">It is stated for the record that {appointment__ceo__names}&nbsp;is, in terms of section 16.1 of the Occupational Health and Safety Act 85/1993, defined as the <strong>Chief Executive Officer (CEO)</strong> of {site__client_name}<strong>.</strong></p><p><br></p><p><strong>Definition:</strong></p><p>(iv) "chief executive officer", in relation to a body corporate or an enterprise conducted by the State, means the person who is responsible for the overall management and control of the business of such body corporate or enterprise.</p><p><br></p><p><strong>Section16:</strong></p><p>Chief executive officer charged with certain duties:</p><p>Every Chief Executive officer shall as far as is reasonably practicable ensure that the duties of his employer as contemplated in this Act, are properly discharged.</p><p><br></p><p><strong>Section8:</strong></p><p>General duties of employers to their employees</p><p>8. (1) Every employer shall provide and maintain, as far as is reasonably practicable, a working environment that is safe and without risk to the health of his employees.</p><p>(2) Without derogating from the generality of an employer's duties under subsection (1), the matters to which those duties refer include in particular-</p><p>the provision and maintenance of systems of work, plant and machinery that, as far as is reasonably practicable; are safe and without risks to health;</p><p>taking such steps as may be reasonably practicable to eliminate or mitigate any hazard or potential hazard to the safety or health of employees, before resorting to personal protective equipment;</p><p>making arrangements for ensuring, as far as is reasonably practicable, the safety and absence of risks to health in connection with the production, processing, use, handling, storage or transport of articles or substances;</p><p>establishing, as far as is reasonably practicable, what hazards to the health or safety of persons are attached to any work which is performed, any article or substance which is produced, processed, used, handled, stored&nbsp;or transported and any plant or machinery which is used in his business, and he shall, as far as is reasonably practicable, further establish what precautionary measures should be taken with respect to such work, article, substance, plant or machinery in order to protect the health and safety of persons, and he shall provide the necessary means to apply such precautionary measures;</p><p>providing such information, instructions, training and supervision as 5 may be necessary to ensure, as far as is reasonably practicable, the health and safety at work of his employees;</p><p>as far as is reasonably practicable, not permitting any employee to do any work or to produce, process, use, handle, store or transport any article or substance or to operate any plant or machinery, unless the precautionary measures contemplated in paragraphs (b) and (d), or any other precautionary measures which may be prescribed,- have been taken;</p><p>taking all necessary measures to ensure that the requirements of this Act are complied with by every person in his employment or on premises under his control where plant or machinery is used;</p><p>enforcing such measures as may be necessary in the interest&nbsp;of health and safety</p><p>ensuring that work is performed and that plant or machinery is used under the general supervision of a person trained to understand the hazards associated with it and who have the authority to ensure that precautionary measures taken by the employer are implemented; and causing all employees to be informed regarding the scope of their authority as contemplated in section 37(1)(b).</p><p><br></p><p class="ql-align-center"><strong style="color: rgb(255, 0, 0);">The CEO reserves the right in terms of the Occupational Health and Safety Act, Act 85 of 1993 to appoint a person or persons to roles and responsibilities within the company.</strong></p><p class="ql-align-center"><br></p><p class="ql-align-center"><strong style="color: rgb(0, 0, 0);">This appointment is valid until completion of the {site__name} project.</strong></p><p class="ql-align-center"><strong style="color: rgb(255, 0, 0);">You are required to report any deviations of the above–mentioned instructions to the 16.1 / 16.2.</strong>&nbsp;</p><p class="ql-align-center"><br></p><p>Signed by: {appointment__ceo__signature_name}</p><p>{appointment__ceo__single__signature}</p><p>TODO: signature_date</p>`,
      //       replacements: '{"appointment__ceo__names":["Francois van Rensburg","test3 ","REHAN JACO VAN DER MERWE",", "],"site__client_name":null,"site__name":"Hogs Head - Automotive"}',
      //       created_at: '2025-03-29T12:37:22.067611',
      //       deleted_at: null
      //   },
      //   document_signature: {
      //     document_signature_id: 'ca7bcca0-1b4b-468c-bd7e-51245d52556e',
      //       document_appointment_request_id: '0b911a54-d66c-439e-9f0b-bfcd50d0cb5b',
      //       employee_id: '977af8b6-c0fa-44f7-ae9d-a6dcc5ebff77',
      //       signature_place_holder: '{appointment__ceo__single__signature}',
      //       signature_name: 'test3 ',
      //       signature_s3_url: null,
      //       signed_at: null,
      //       signed_location: null,
      //       signature_place_holder_name: '{appointment__ceo__signature_name}'
      //   },
      //   employee_signature: 'employee/signature/977af8b6-c0fa-44f7-ae9d-a6dcc5ebff77',
      //     canSign: true
      // }
      console.log("resp == ", resp);
    } catch (e) {
      console.log("Error == ", e);
    }
    finally {
      modalProps.setGlobalLoading(false);
    }
  }
  React.useEffect(() => {
    fetchData();
  }, []);



  function renderHtml() {
    if (!document || !documentSignature) {
      return;
    }

    let rawDocument = document.content;
    const replacements = Object.entries(JSON.parse(document.replacements));
    for (const [key, value] of replacements) {
      if (key.endsWith("_list")) {
        const htmlListItems = (value as string[]).map((item: string) =>
          `<li style="list-style-type: inherit;padding-left: 0;position: inherit;">${item}</li>`
        ).join("");
        rawDocument = rawDocument.replaceAll(`{${key}}`, `<ul>${htmlListItems}</ul>`);
        continue;
      }
      rawDocument = rawDocument.replaceAll(`{${key}}`, value);
    }
    rawDocument = rawDocument.replaceAll(`${documentSignature.signature_place_holder_name}`, documentSignature.signature_name);
    const today = dayjs();
    const todayFormatted = today.format('D MMMM YYYY');
    rawDocument = rawDocument.replaceAll(`${documentSignature.signature_place_holder_signed_at}`, todayFormatted);

    let signatureIndex = 0;
    const options: HTMLReactParserOptions = {
      replace(domNode) {
        if (domNode.type === "text") {
          if (domNode.data === documentSignature.signature_place_holder) {
            const currentIndex = ++signatureIndex;
            setTotalSignatures(currentIndex);
            return <>
              <div
                data-signature-index={currentIndex}
                className="signature-image-container"
                style={{
                  height: "80px",
                  width: "250px",
                  border: "1px dashed #ccc",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: documentSignaturesClicked.includes(currentIndex) ? "transparent" : "#f5f5f5",
                  cursor: !canSign ? "no-drop" : "pointer",//documentSignaturesClicked.includes(currentIndex) ? "default" : "pointer",
                  margin: "5px 0"
                }}
                onClick={() => signatureClicked(currentIndex)}
              >
                {documentSignaturesClicked.includes(currentIndex) ? (
                  <img
                    src={employeeSignature}
                    alt="Signature"
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                  />
                ) : (
                  <span>Click to add signature</span>
                )}
              </div>
            </>
          }
          else if (domNode.data !== documentSignature.signature_place_holder &&
            domNode.data.startsWith("{appointment__") &&
            (domNode.data.endsWith("__signature_name}") ||
              domNode.data.endsWith("__signature}") ||
              domNode.data.endsWith("__signature_signed_at}"))
          ) {
            // Signature someone else needs to sign.
            const appointmentName = domNode.data.split("__")[1].charAt(0).toUpperCase() + domNode.data.split("__")[1].slice(1);
            if (domNode.data.endsWith("__signature_name}")) {
              return <div style={{ color: "rgba(0,0,0,0.5)", marginTop: 0, marginBottom: 5, padding: 0 }}>? {appointmentName} Name ?</div>;
            }
            else if (domNode.data.endsWith("__signature}")) {
              return <div style={{ color: "rgba(0,0,0,0.5)", marginTop: 0, marginBottom: 5, padding: 0 }}>? {appointmentName} Signature ?</div>;
            }
            else if (domNode.data.endsWith("__signature_signed_at}")) {
              return <div style={{ color: "rgba(0,0,0,0.5)", marginTop: 0, marginBottom: 5, padding: 0 }}>? {appointmentName} Signed At ?</div>;
            }
          }
        }


      },
    };
    setHtml(parse(rawDocument, options));
  }

  React.useEffect(() => {
    console.log("React.useEffect => documentSignaturesClicked == ", documentSignaturesClicked);
    renderHtml();
  }, [
    document, documentSignature, employeeSignature, canSign,
    /* Elements dynamically added */
    documentSignaturesClicked
  ]);

  return (
    <React.Fragment>
      {employee && (
        <div style={{ backgroundColor: "#dcdcdc", padding: "20px", borderRadius: "10px", marginBottom: "10px" }}>
          <div>
            <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Employee</span>: {employee.name} {employee.surname}</p>
            <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Site</span>: {employee.site_name}</p>
            {employee.appointment_name && (
              <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Appointment</span>: {employee.appointment_name}</p>
            )}
            <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Created At</span>: {formatDateTime(document.created_at)}</p>
          </div>
        </div>
      )}

      <div className="ql-editor">
        {html}
      </div>

      <Button type="button" icon="" className="p-button-outlined" size="small"
        label={documentSignaturesClicked.length === totalSignatures ? "Complete Signature" : `Sign all fields(${documentSignaturesClicked.length}/${totalSignatures})`}
        disabled={documentSignaturesClicked.length !== totalSignatures}
        style={{ display: "flex", color: "#2dd36f", marginLeft: "auto" }} onClick={() => sign()} />
      <Toast ref={toast} />
    </React.Fragment>
  );
}